module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradeCalcPage"
  }, [_c('div', {
    staticClass: "entries"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "previousResults"
  }, [_vm._v(" Previous grade information:")]), _vm._v(" "), _c('div', {
    staticClass: "existingGrades"
  }, [_c('p', [_vm._v("GPA: \n  \t      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prevGPA),
      expression: "prevGPA"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.prevGPA)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prevGPA = $event.target.value
      }
    }
  }), _vm._v("\n  \t        Credit Hours: \n  \t      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prevCreditHours),
      expression: "prevCreditHours"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.prevCreditHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prevCreditHours = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "header"
  }, [_vm._v("  Letter    Credit Hours")]), _vm._v(" "), _c('div', {
    staticClass: "gpaGrades"
  }, _vm._l((_vm.grades), function(grade) {
    return _c('div', {
      staticClass: "grade"
    }, [_vm._v("\n  \t       "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.letter),
        expression: "grade.letter"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.letter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.letter = $event.target.value
        }
      }
    }), _vm._v("\n  \t         "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grade.creditHours),
        expression: "grade.creditHours"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (grade.creditHours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          grade.creditHours = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.addGrade
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.removeGrade
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetEntries
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('div', {
    staticClass: "output"
  }, [_c('h3', [_vm._v(" Your GPA is " + _vm._s(_vm.calculateGrade))])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "predGrade"
  }, [_vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Enter remaining credit hours: ")]), _vm._v(" "), _c('div', {
    staticClass: "gradesToGo"
  }, [_c('div', {
    staticClass: "grade"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.final.creditHours),
      expression: "final.creditHours"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.final.creditHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.final.creditHours = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter/Slide Desired GPA:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 3.00,
      "max": 4.00,
      "interval": .01,
      "width": 500
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.resetPred
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "predOutput"
  }, [_c('h3', [_vm._v(" You need an average GPA of " + _vm._s(_vm.predictGrade) + " to get a " + _vm._s(_vm.value))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("Current Grade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gpaDisplay"
  }, [_c('table', {
    staticClass: "gpaTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "gpaHeader"
  }, [_c('th', [_vm._v("Letter")]), _c('th', [_vm._v("GPA")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("A")]), _c('th', [_vm._v("4.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("A-")]), _c('th', [_vm._v("3.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B+")]), _c('th', [_vm._v("3.33")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B")]), _c('th', [_vm._v("3.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B-")]), _c('th', [_vm._v("2.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C+")]), _c('th', [_vm._v("2.33")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C")]), _c('th', [_vm._v("2.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C-")]), _c('th', [_vm._v("1.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D+")]), _c('th', [_vm._v("1.33")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D")]), _c('th', [_vm._v("1.00")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D-")]), _c('th', [_vm._v("0.67")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("F")]), _c('th', [_vm._v("0.00")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "predHeader"
  }, [_c('u', [_vm._v("Predicted Grade")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b08c8ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GPA.vue
// module id = 24
// module chunks = 0